const PERMISSION_KEY= "personalize:nebula_trading_transaction";
const PAGE_URL = {
    NEBULA_TRADING_TRANSACTION_PAGE: "/admin/personalize/nebula-trading-transaction"
}

export {PERMISSION_KEY, PAGE_URL}

